import usePut from "../usePut";
import toast from "react-hot-toast";

export const useDeleteSalaryTemplate = ({ onDelete }) => {
  const { handleAuth: deleteReq } = usePut({
    url: "template-salary-structure/delete",
    refreshUrl: ["template-salary-structure/list"],
    onSuccess: (data) => {
      toast.success("Template deleted successfully");
      if (onDelete) onDelete(data);
    },
    onError: (error) => {
      toast.error("Failed to delete template: " + error?.message);
    },
  });
  const isDeleting = deleteReq.isLoading;

  const deleteTemplate = (templateId) => {
    // Call the delete API with the templateId
    deleteReq.mutate({ template_id: templateId });
  };

  return { deleteTemplate, isDeleting };
};
